import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import { Editing } from "devextreme-react/scheduler";
import { Button } from "devextreme-react";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarTaxasDs,
  criarReceitasDs,
} from "../../DataSources";
import uiInfo from "../../ui-info";
import {
  Column,
  DataGrid,
  Paging,
  Pager,
  Lookup,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  descricao: "",
  valor: undefined,
  receitaId: undefined,
  tipoDeCobranca: 0,
  tipoTaxa: 0,
  moeda: 0,
  unidadeBaseCalculo: "",
  faixas: [],
};

export default class TaxasForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...(_cadastroCorrente || template) };
    template.prefeituraId = UserInfo.getPrefeitura();
    this.taxasDs = criarTaxasDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;

    this.opcoesTipoTaxaLancamento = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Taxas Diversas" },
        { id: 1, descricao: "Alvará Funcionamento" },
        { id: 2, descricao: "Alvará Sanitário" },
        { id: 3, descricao: "Alvará Diversos" },
        { id: 4, descricao: "Habite-se" },
        { id: 5, descricao: "Habite-se (por m²)" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };

    this.moedaOpcoes = {
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "Real" },
        { id: 1, descricao: "Unidade Fiscal" },
      ],
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.taxasDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            console.log("data didmount", data);
            if (data == undefined) {
              notify("Taxa não encontrada.", "error");
              this.props.history.push("/taxas");
            }
            console.log("data taxa", data);
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }

    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id === undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  render() {
    const receitaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarReceitasDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };
    const tiposDeCobranca = [
      { id: 0, descricao: "Por Quantidade" },
      { id: 1, descricao: "Por Faixa" },
      { id: 2, descricao: "Por Valor Fixo (R$)" },
      { id: 3, descricao: "Por Faixa (Tabela Preços)" },
    ];

    const tiposDeCobrancaFaixa = [
      { id: 0, descricao: "Fixa" },
      { id: 1, descricao: "Variavel" },
      { id: 2, descricao: "Mista Integral" },
      { id: 3, descricao: "Mista Fracionável" },
      { id: 4, descricao: "Mista (sem desc/ início)" },
    ];

    const cobrancasOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tiposDeCobranca,
      valueExpr: "id",
      displayExpr: "descricao",
      onValueChanged: (e) => this.setState({ tipoDeCobranca: e.value }),
    };

    const cobrancasFaixaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: tiposDeCobrancaFaixa,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={5}>
          <GroupItem caption="TAXAS" colSpan={5} colCount={5}>
            <SimpleItem dataField={"descricao"} colSpan={5}>
              <Label text="Descrição" />
            </SimpleItem>
            <SimpleItem
              dataField={"receitaId"}
              editorType={"dxLookup"}
              editorOptions={receitaOptions}
              colSpan={5}
            >
              <Label text="Receita" />
            </SimpleItem>
            <SimpleItem
              dataField={"tipoDeCobranca"}
              editorType={"dxSelectBox"}
              editorOptions={cobrancasOptions}
              colSpan={2}
            >
              <Label text="Tipo de Cobrança" />
            </SimpleItem>
            <EmptyItem colSpan={3} />
            <SimpleItem
              dataField={"tipoTaxa"}
              editorType={"dxSelectBox"}
              editorOptions={this.opcoesTipoTaxaLancamento}
              colSpan={2}
            >
              <Label text="Tipo Taxa" />
            </SimpleItem>
            <EmptyItem colSpan={3} />

            <SimpleItem
              dataField={"moeda"}
              editorType={"dxSelectBox"}
              editorOptions={this.moedaOpcoes}
              colSpan={2}
            >
              <Label text="Moeda" />
            </SimpleItem>

            <EmptyItem colSpan={3} />

            <SimpleItem
              dataField={"valor"}
              colSpan={2}
              editorType={"dxNumberBox"}
              editorOptions={{
                format: uiInfo.formatoNumerico.n2,
                readOnly:
                  this.state.tipoDeCobranca === 2 ||
                  this.state.tipoDeCobranca === 0
                    ? false
                    : true,
              }}
              cssClass={"txtFormNumerico"}
            >
              <Label text="Valor" />
            </SimpleItem>

            <EmptyItem colSpan={3} />

            <SimpleItem dataField={"unidadeBaseCalculo"} colSpan={2}>
              <Label text="Unid. Base Cálculo" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <div
          style={{
            display:
              this.state.tipoDeCobranca === 1 || this.state.tipoDeCobranca === 3
                ? ""
                : "none",
          }}
        >
          <PaginaToolbar titulo="Faixa">
            <DataGrid
              dataSource={this.state.faixas}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              onInitNewRow={this.initNewRow}
            >
              <Editing
                mode={"row"}
                allowAdding={false}
                allowUpdating={true}
                allowDeleting={true}
              />
              <Column
                dataField={"id"}
                caption={"#"}
                width={"80"}
                allowEditing={false}
                visible={false}
              />
              <Column
                dataField={"paiId"}
                caption={"Id do Fator"}
                visible={false}
              />
              <Column
                dataField={"prefeituraId"}
                caption={"Prefeitura"}
                visible={false}
              />

              <Column
                dataField={"valorInicial"}
                caption={"Inicial"}
                dataType={"number"}
                editorType={"dxNumberBox"}
                format={uiInfo.formatoNumerico.n2}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              />

              <Column
                dataField={"valorFinal"}
                caption={"Final"}
                dataType={"number"}
                editorType={"dxNumberBox"}
                format={uiInfo.formatoNumerico.n2}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              />

              <Column
                dataField={"valor"}
                caption={"Valor (R$)"}
                dataType={"number"}
                editorType={"dxNumberBox"}
                format={uiInfo.formatoNumerico.n2}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              />

              <Column
                dataField={"tipoDeFaixa"}
                caption={"Tipo de Faixa"}
                editorType={"dxLookup"}
                editorOptions={cobrancasFaixaOptions}
              >
                <Lookup
                  dataSource={tiposDeCobrancaFaixa}
                  displayExpr={"descricao"}
                  valueExpr={"id"}
                />
              </Column>

              <Column
                dataField={"valorFixoAdicional"}
                caption={"Vr. Fixo (Adicional)"}
                dataType={"number"}
                format={uiInfo.formatoNumerico.n2}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              />

              <Column
                dataField={"fracao"}
                caption={"Fração"}
                dataType={"number"}
                editorType={"dxNumberBox"}
                format={uiInfo.formatoNumerico.n2}
                editorOptions={{ format: uiInfo.formatoNumerico.n2 }}
              />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
        <br></br>
        <div
          style={{
            display: "flex",
            marginTop: "25px",
            justifyContent: "center",
            alignContent: "center",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          <div style={{ display: "inline-block" }}>
            <Button
              width={120}
              text="Salvar"
              type="success"
              onClick={this.ok}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft: "10px" }}>
            <Button
              width={120}
              text="Cancelar"
              type="danger"
              onClick={this.cancel}
            />
          </div>
        </div>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
    e.data.tipoDeFaixa = 0;
  }

  ok() {
    const entidade = this.state;
    console.log("entidade", entidade);
    inserirOuAtualizar(this.taxasDs, entidade)
      .then(
        function () {
          _cadastroCorrente = undefined;
          _cancelando = true;
          notify("Taxa cadastrada com sucesso.", "success");
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
